module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/204.c3a6d119.png";